import styled from "styled-components";
import { theme } from "@themes";

export const CreatePolicySection = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.neutral.white};
  .heading-label {
    font-weight: 700;
  }
  .mandatory {
    color: #ed0707;
  }
`;

export const SubPolicyModalContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  height: 100%;
`;

export const SubPolicyModalHeader = styled.div`
  margin: 10px;
  border-bottom: 2px solid ${({ theme }) => theme.neutral.gray[900]};
  label {
    font-size: 1.2rem;
    font-weight: 700;
    margin: 10px;
  }
  button {
    float: right;
  }
`;

export const LocationFieldContainer = styled.div`
  margin: 15px;
  max-width: 25rem;
  .location-dropdown {
    margin-top: 10px;
    width: 100%;
  }
`;
export const MainPolicyContainer = styled.div`
  margin: 15px;
  display: flex;
  flex-direction: column;
  max-width: 25rem;
  input {
    outline: none;
    border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
    padding: 10px;
    border-radius: 5px;
  }
`;
export const SubPolicyContainer = styled.div`
  margin-bottom: 4rem;
  .add-policy-btn {
    padding: 5px;
    border-radius: 5px;
    outline: none;
    background-color: ${({ theme }) => theme.neutral.white};
    width: 188px;
    height: 40px;
    border: 1px solid ${({ theme }) => theme.primary.purpleMedium};
    color: ${({ theme }) => theme.primary.purpleMedium};
    font-weight: 600;

    span {
      margin: 5px;
      color: ${({ theme }) => theme.primary.purple};
    }
  }
`;

export const SubPolicyFieldContainer = styled.div`
  display: flex;
  margin: 15px;
  justify-content: flex-start;
  padding-right: 20px;
`;
export const PolicyActionButton = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  button {
    margin: 15px;
    width: 112px;
    height: 40px;
    outline: none;
    border: none;
    background-color: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 5px;
  }
  .cancel-btn {
    background-color: ${({ theme }) => theme.neutral.white};
    color: ${({ theme }) => theme.neutral.black};
    border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  }
`;
export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};

export const SubPolicies = styled.div`
  margin: 20px;
  height: 100%;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }

  @media only screen and (min-height: 300px) and (max-height: 700px) {
    height: 100%;
  }
`;

export const LocationMainPolicyContainer = styled.div`
  display: grid;
  grid-template-columns: 35% 35%;

  @media only screen and (min-width: 1920px) and (max-width: 2500px) {
    grid-template-columns: 28% 35%;
  }

  @media only screen and (min-width: 2501px) and (max-width: 3000px) {
    grid-template-columns: 20% 35%;
  }
`;
export const TextField = styled.div`
  input,
  select {
    padding: 0.5em;
    height: 38px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
  label {
    color: #cc0000;
  }
  input::placeholder {
    font-size: 12px;
  }
  .lock-icon {
    position: absolute;
    right: 5px;
    top: 9px;
    font-size: 17px;
  }
`;

export const GeneralContainerCreatePolicy = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
`;
